import { Component } from '@angular/core';
import { HeaderConfiguration } from 'src/app/shared/components/header/header.component';
import { Title } from 'src/app/shared/components/title/title.component';
import { JsonConfiguration } from './json';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-calculator',
  templateUrl: './calculator.component.html',
  styleUrls: ['./calculator.component.scss'],
  providers: [JsonConfiguration],
})
export class CalculatorComponent {
  titleData: Title = this.jsonConfiguration.titleData;
  headerConfiguration: HeaderConfiguration = this.jsonConfiguration.headerConfiguration;

  constructor(private jsonConfiguration: JsonConfiguration) {}
}
